<icon type="mat_warning" class="head"></icon>

<p>You're keen, but this section cannot be used until...</p>

<components-list flow="column" density="high">
  @for (todo of todos; track todo) {
  <todo [all]="todos" [todo]="todo"></todo>
  }
</components-list>
